const theme = {
  colors: {
    primary: '#111B40',
    secondary: '#EB005C',
    muiPrimary: '#1976D2',
    gray: '#BABABA',
    lightGray: '#DADADA',
    lightestGray: '#F6F6F6',
    skyblue: '#D7ECFF',
  }
}

export default theme